module.exports = __webpack_public_path__ + "img/icon4.c227fb3b.svg";